import jQuery from "jquery";
import {ZIDX} from "./standalone/standaloneLibrary.js";
import {SavedListingRepository} from "./standalone/saved-listings/SavedListingRepository.js";

const $=jQuery.noConflict();
export class ZIDXModalWindow{
    zidx:ZIDX;
    zModalObjectHidden=new Array();
    zModalScrollPosition=new Array();
    zArrModal:any[]=[];
    zModalPosIntervalId:number|NodeJS.Timeout=0;
    zModalIndex=0;
    zModalKeepOpen=false;
    zModalSideReduce=30;
    zScrollbarWidth=0;
    zCurrentHash="";
    modalIndexId=1;
    zIsTouchscreenCache=0;
    private wasLoggedInBeforeModal=false;
    constructor(zidx:ZIDX) {
        this.zidx= zidx;
        let self=this;
        // @ts-ignore
        window.zidxCloseAllModalWindows=function(){
            for(let i=0;i<10;i++) {
                $(".zCloseModalButton"+i, self.zidx.peakidxShadowRoot).trigger("click");
            }
            // Check if user just logged in and sync listings
            self.checkLoginAndSync();
        }
    }

    private checkLoginAndSync() {
        // If user wasn't logged in before modal opened but is now, trigger sync
        if (!this.wasLoggedInBeforeModal && this.zidx.isContactLoggedIn() && !this.zidx.isContactGuest()) {
            const repo = SavedListingRepository.getInstance(this.zidx);
            // Check if there's a guest account to migrate
            if (repo.getGuestContactId() > 0 && !repo.isGuestAccount()) {
                console.log("User logged in via modal, migrating guest account...");
                repo.migrateGuestToReal();
            } else {
                console.log("User logged in via modal, syncing listings...");
                repo.syncWithServer();
            }
        }
    }

    public setWasLoggedInBeforeModal(value: boolean) {
        this.wasLoggedInBeforeModal = value;
    }
 
    showModalStandard(url:string, maxWidth:number, maxHeight:number, disableClose:boolean, fullscreen:boolean, padding:number){
        var windowSize=this.getClientWindowSize();
        if(url.indexOf("?") === -1){
            url+="?";
        }else{
            url+="&";
        }
        if(typeof maxWidth === "undefined"){
            maxWidth=3000;
        }
        if(typeof maxHeight === "undefined"){
            maxHeight=3000;
        }
        if(typeof disableClose === "undefined"){
            disableClose=false;
        }
        if(typeof fullscreen === "undefined"){
            fullscreen=false;
        }
        if(typeof padding === "undefined"){
            padding=20;
        }
        this.zModalSideReduce=10;
        if(disableClose){
            this.zModalSideReduce=0;
            padding=0;
        }else if($(window).width()! < 550){
            this.zModalSideReduce=10;
            if(padding != 0){
                padding=10;
            }
        }
        this.modalIndexId++;
        var modalContent1='<iframe id="'+"zModalIframe"+this.modalIndexId+'" src="'+url+'ztv='+Math.random()+'" scrolling="yes" frameborder="0"  style=" margin:0px; border:none; overflow:auto; -webkit-overflow-scrolling: touch; position:relative; " seamless="seamless" width="100%" height="98%" />';
        this.showModal(modalContent1,{
            'width':maxWidth, // windowSize.width-this.zModalSideReduce
            'height':maxHeight, // , windowSize.height
            "maxWidth":maxWidth,
            "maxHeight":maxHeight,
            "padding":padding,

            "disableClose":disableClose,
            "fullscreen":fullscreen});

    }
    fixModalPos(){
        this.zScrollbarWidth=1;
        this.getClientWindowSize();
        var windowSize=this.zidx.windowSize;

        for(var i=1;i<=this.zModalIndex;i++){
            var el = this.zidx.peakidxShadowRoot.getElementById("zModalOverlayDivContainer"+i)!;
            var el2 = this.zidx.peakidxShadowRoot.getElementById("zModalOverlayDivInner"+i)!;
            this.zArrModal[i].scrollPosition=[
                self.pageXOffset ||
                document.documentElement.scrollLeft ||
                document.body.scrollLeft
                ,
                self.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop
            ];
            if(isNaN(this.zArrModal[i].modalWidth)){
                this.zArrModal[i].modalWidth=10000;
            }
            if(isNaN(this.zArrModal[i].modalHeight)){
                this.zArrModal[i].modalHeight=10000;
            }

            el.style.top=this.zArrModal[i].scrollPosition[1]+"px";
            el.style.left=this.zArrModal[i].scrollPosition[0]+"px";
            if(this.zArrModal[i].fullscreen){
                var newWidth=windowSize.width-(this.zModalSideReduce*2);
                var newHeight=windowSize.height-(this.zModalSideReduce);
            }else{
                var newWidth=Math.min(this.zArrModal[i].modalWidth, Math.min(windowSize.width-(this.zModalSideReduce*2),((this.zArrModal[i].modalMaxWidth))));
                var newHeight=Math.min(this.zArrModal[i].modalHeight, Math.min(windowSize.height-(this.zModalSideReduce),((this.zArrModal[i].modalMaxHeight))));
            }
            var finalWidth=newWidth;
            var finalHeight=newHeight;
            if(windowSize.width < 768 && this.zArrModal[i].modalMaxMobileWidth < 768){
                finalWidth=this.zArrModal[i].modalMaxMobileWidth;
                finalHeight=this.zArrModal[i].modalMaxMobileHeight;
            }

            // Calculate initial position
            var left=Math.round(Math.max(0, windowSize.width-finalWidth)/2);
            var top=Math.round(Math.max(0, windowSize.height-finalHeight)/2);

            // Handle overflow - if modal is taller than viewport
            if(finalHeight > windowSize.height) {
                top = 50; // Minimum top margin
                finalHeight = windowSize.height - (top * 2); // Adjust height to fit with margins
            }

            el2.style.left=left+'px';
            el2.style.top=top+'px';

            if(this.zArrModal[i].forceSize){
                if(windowSize.width < 768 && this.zArrModal[i].modalMaxMobileWidth < 768){
                    finalWidth=this.zArrModal[i].modalMaxMobileWidth;
                    finalHeight=this.zArrModal[i].modalMaxMobileHeight;
                }else{
                    finalWidth=this.zArrModal[i].modalWidth;
                    finalHeight=this.zArrModal[i].modalHeight;
                }
            }else if(!this.zArrModal[i].disableResize){
                if(windowSize.width < 768 && this.zArrModal[i].modalMaxMobileWidth < 768){

                }else{
                    if(this.zArrModal[i].disableClose){
                        finalWidth=finalWidth-(this.zArrModal[i].padding);
                        finalHeight=finalHeight-(this.zArrModal[i].padding);
                    }else{
                        finalWidth=finalWidth-(this.zArrModal[i].padding)-5;
                        finalHeight=finalHeight-(this.zArrModal[i].padding)-22;
                    }
                }
                el2.style.width=finalWidth+"px";
                el2.style.height=finalHeight+"px";
            }
            $(".zCloseModalButton"+i, this.zidx.peakidxShadowRoot).css({
                "right":"20px",
                "top":"10px"
            });

        }
    }
    stopBodyScrolling (bool:boolean) {

        let self=this;
        if (bool === true) {
            document.body.addEventListener("touchmove", function(e){self.freezeVp(e);}, false);
        } else {
            document.body.removeEventListener("touchmove", function(e){self.freezeVp(e);}, false);
        }
    }
    freezeVp(e:TouchEvent) {
        e.preventDefault();
    }
    showModal(content:string, obj:any){
        // var d=document.body || document.documentElement;
        var d=document.documentElement;//"#zidxComponentContainer", this.zidx.peakidxShadowRoot)[0];
        let self=this;
        this.zModalIndex++;
        this.zArrModal[this.zModalIndex]={
            "disableClose":false,
            "padding":0,
            "disableResize":false,
            "modalMaxWidth":10000,
            "modalMaxHeight":10000,
            "modalMaxMobileWidth":10000,
            "modalMaxMobileHeight":10000,
            "modalWidth":10000,
            "modalHeight":10000,
            "fullscreen":false,
            "forceSize":false
        };
        if(typeof obj.fullscreen !== "undefined" && obj.fullscreen){
            this.zArrModal[this.zModalIndex].fullscreen=obj.fullscreen;
        }
        if(typeof obj.disableResize !== "undefined" && obj.disableResize){
            this.zArrModal[this.zModalIndex].disableResize=obj.disableResize;
        }
        if(typeof obj.forceSize !== "undefined" && obj.forceSize){
            this.zArrModal[this.zModalIndex].forceSize=obj.forceSize;
        }
        var disableClose=false;
        if(typeof obj.disableClose !== "undefined" && obj.disableClose){
            disableClose=obj.disableClose;
            this.zArrModal[this.zModalIndex].disableClose=obj.disableClose;
        }
        if(typeof obj.padding !== "undefined"){
            this.zArrModal[this.zModalIndex].padding=obj.padding;
        }
        var b='';
        if(!disableClose){
            b='<a href="#" class="zidxDisableSPALink zCloseModalButton'+this.zModalIndex+'" style="width:80px; text-align:right; right:0px; top:0px; position:relative; float:left;  font-weight:bold; color:#FFF !important;">X Close</a>';
        }
        var h='<div id="zModalOverlayDivContainer'+this.zModalIndex+'" class="zModalOverlayDiv"><div id="zModalOverlayDivInner'+this.zModalIndex+'" class="zModalOverlayDiv2" style=" -webkit-overflow-scrolling: touch !important; overflow:hidden !important;"></div></div>';
        let tempDiv=document.createElement("div");
        tempDiv.innerHTML=h;
        // @ts-ignore
        if(this.zidx.peakidxShadowRoot.body) {
            // @ts-ignore
            this.zidx.peakidxShadowRoot.body.appendChild(tempDiv.firstChild!);
        }else{
            this.zidx.peakidxShadowRoot.appendChild(tempDiv.firstChild!);
        }
        $(document).off("keydown.zidxModal").on("keydown.zidxModal", function(e:JQuery.KeyDownEvent){
            // if esc key is pressed, close the top modal
            if(e.keyCode === 27 && !self.zModalKeepOpen && self.zModalIndex > 0){
                self.zidx.modalWindow.closeModal();
            }
        });

        var windowSize=this.zidx.windowSize;
        this.zArrModal[this.zModalIndex].modalWidth=obj.width;
        this.zArrModal[this.zModalIndex].modalHeight=obj.height;
        if(this.zArrModal[this.zModalIndex].fullscreen){
            obj.width=windowSize.width;
            obj.height=windowSize.height;
        }else{
            obj.width=Math.min(this.zArrModal[this.zModalIndex].modalMaxWidth, Math.min(obj.width, windowSize.width));
            obj.height=Math.min(this.zArrModal[this.zModalIndex].modalMaxHeight, Math.min(obj.height, windowSize.height));
        }
        if(typeof obj.maxWidth !== "undefined"){
            this.zArrModal[this.zModalIndex].modalMaxWidth=obj.maxWidth;
        }
        if(typeof obj.maxHeight !== "undefined"){
            this.zArrModal[this.zModalIndex].modalMaxHeight=obj.maxHeight;
        }
        if(typeof obj.maxMobileWidth !== "undefined"){
            this.zArrModal[this.zModalIndex].modalMaxMobileWidth=obj.maxMobileWidth;
        }
        if(typeof obj.maxMobileHeight !== "undefined"){
            this.zArrModal[this.zModalIndex].modalMaxMobileHeight=obj.maxMobileHeight;
        }
        this.zArrModal[this.zModalIndex].scrollPosition = [
            window.pageXOffset ||
            document.documentElement.scrollLeft ||
            document.body.scrollLeft
            ,
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop
        ];
        if(this.zModalIndex==1){
            var arr = $(".zModalOverlayDiv2 iframe", this.zidx.peakidxShadowRoot);
            for(var i=0;i<arr.length;i++){
                if(arr[i].style.visibility==="" || arr[i].style.visibility === "visible"){
                    arr[i].style.visibility="hidden";
                    this.zModalObjectHidden.push(arr[i]);
                }
            }
        }
        this.stopBodyScrolling(true);
        var el = this.zidx.peakidxShadowRoot.getElementById("zModalOverlayDivContainer"+this.zModalIndex)!;
        var el2 = this.zidx.peakidxShadowRoot.getElementById("zModalOverlayDivInner"+this.zModalIndex)!;
        el.style.display = "block";
        el2.style.display = "block";
        el2.onclick=function(){
            self.zModalKeepOpen=true;
            setTimeout(function(){self.zModalKeepOpen=false;},100);
            // return false;
        };
        el2.innerHTML=b+content;
        if(disableClose){
            el.onclick=function(){};
        }else{
            el.onclick=function(){
                if(self.zModalKeepOpen) return;
                // console.log("close modal by overlay click");
                self.closeModal();
            };
        }
        $(".zCloseModalButton"+this.zModalIndex, this.zidx.peakidxShadowRoot).on("click", function(e:JQuery.ClickEvent){
            e.preventDefault();
            self.zidx.modalWindow.closeModal();
        });


        if($(".zModalOverlayDiv2 iframe", this.zidx.peakidxShadowRoot).length){
            if(!self.zIsTouchscreen()){
                $(".zModalOverlayDiv2").css("overflow", "hidden");
            }
            $(".zModalOverlayDiv2 iframe", this.zidx.peakidxShadowRoot).height("100%");
            $(".zModalOverlayDiv2 iframe", this.zidx.peakidxShadowRoot).css("position", "relative");
        }else{
            if(!self.zIsTouchscreen()){
                $(".zModalOverlayDiv2", this.zidx.peakidxShadowRoot).css("overflow", "auto");
            }
        }
        el.style.top="-1000px";
        el.style.left=this.zArrModal[this.zModalIndex].scrollPosition[0]+"px";
        el.style.height="100%";
        el.style.width="100%";
        var left=Math.round(Math.max(0,((windowSize.width)-obj.width))/2);
        var top=Math.round(Math.max(0, (windowSize.height-obj.height))/2);

        // Handle cases where modal is taller than viewport
        if(obj.height > windowSize.height) {
            top = 50; // Minimum top margin
            obj.height = windowSize.height - (top * 2); // Adjust height to fit with margins
        }
        // console.log("modal top", top, obj.height);
        el2.style.left=left+'px';
        el2.style.top=top+'px';
        if(this.zArrModal[this.zModalIndex].disableClose){
            el2.style.width=(obj.width-(this.zArrModal[this.zModalIndex].padding))+"px";
            el2.style.height=(obj.height-(this.zArrModal[this.zModalIndex].padding))+"px";
        }else{
            el2.style.width=(obj.width-(this.zArrModal[this.zModalIndex].padding)-5)+"px";
            el2.style.height=(obj.height-(this.zArrModal[this.zModalIndex].padding)-22)+"px";
        }
        $(".zCloseModalButton"+this.zModalIndex, this.zidx.peakidxShadowRoot).css({
            "right":"10px",
            "top":"10px",
            "position":"absolute",
            "z-index":"10"
        });
        self.zModalPosIntervalId=setInterval(function(){self.fixModalPos();},100);
        self.zCurrentHash="#zModal-"+new Date().getTime()+"-"+Math.random();
        window.location.href=self.zCurrentHash;


        // setTimeout(function() {
        //     let $modal=$("#zModalOverlayDivInner" + self.zModalIndex, self.zidx.peakidxShadowRoot);
        //
        //     const $focusableElements = 'a[href]:not([tabindex="-1"]), area[href]:not([tabindex="-1"]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]):not([tabindex="-1"]), textarea:not([disabled]):not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), iframe:not([tabindex="-1"]), object:not([tabindex="-1"]), embed:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"]), [contenteditable]:not([tabindex="-1"])';
        //     const $firstFocusable = $modal.find($focusableElements).first();
        //     $firstFocusable.trigger("focus");
        //     console.log("First focusable element in modal:", $firstFocusable);
        //     // const $lastFocus = document.activeElement;
        //     $modal.on('keydown', function(e) {
        //         if (e.key === 'Tab') {
        //             const $focusableInModal = $modal.find($focusableElements);
        //             const $first = $focusableInModal.first();
        //             const $last = $focusableInModal.last();
        //
        //             if (e.shiftKey) { // Shift + Tab
        //                 if (document.activeElement === $first[0]) {
        //                     $last.trigger("focus");
        //                     e.preventDefault();
        //                 }
        //             } else { // Tab
        //                 if (document.activeElement === $last[0]) {
        //                     $first.trigger("focus");
        //                     e.preventDefault();
        //                 }
        //             }
        //         }
        //     });
        //
        // }, 500);

    }
    closeModal(){

        this.stopBodyScrolling(false);
        this.zModalSideReduce=30;
        var el = this.zidx.peakidxShadowRoot.getElementById("zModalOverlayDivContainer"+this.zModalIndex);
        if(!el){
            return;
        }
        clearInterval(this.zModalPosIntervalId);
        this.zModalPosIntervalId=0;
        var d=document.body || document.documentElement;

        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
        if(iOS){
            d.style.overflow="auto";
            d.style.position="static";
        }else{
            d.style.overflow="auto";
            d.style.position="initial";
        }
        el.parentNode!.removeChild(el);
        if(this.zModalIndex==1){
            for(var i=0;i<this.zModalObjectHidden.length;i++){
                this.zModalObjectHidden[i].style.visibility="visible";
            }
        }
        this.zModalIndex--;
        if(this.zModalIndex<0){
            this.zModalIndex=0;
        }
        window.history.replaceState({}, document.title, window.location.href.split("#")[0]);
    }

    zIsTouchscreen(){
        if(this.zIsTouchscreenCache!==3){
            return this.zIsTouchscreenCache;
        }
        var n=navigator.userAgent.toLowerCase();

        var patt=/(android|iphone|ipad|viewpad|tablet|bolt|xoom|touchpad|playbook|kindle|gt-p|gt-i|sch-i|sch-t|mz609|mz617|mid7015|tf101|g-v|ct1002|transformer|silk| tab)/g;
        if(n.replace(patt,"anything") !== n){
            this.zIsTouchscreenCache=1;
            return true;
        }else {
            this.zIsTouchscreenCache=0;
            return false;
        }
    }
    getClientWindowSize() {
        var myWidth = 0, myHeight = 0;
        if( typeof( window.innerWidth ) === 'number' ) {
            //Non-IE
            myWidth = window.innerWidth;
            myHeight = window.innerHeight;
        } else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
            //IE 6+ in 'standards compliant mode'
            myWidth = document.documentElement.clientWidth;
            myHeight = document.documentElement.clientHeight;
        } else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
            //IE 4 compatible
            myWidth = document.body.clientWidth;
            myHeight = document.body.clientHeight;
        }
        if(this.zidx.scrollbarWidth===0){
            this.zidx.scrollbarWidth=this.zidx.getScrollBarWidth();
        }
        this.zidx.windowSize={
            "width":myWidth-this.zidx.scrollbarWidth,
            "height":myHeight
        };
        return this.zidx.windowSize;
    }
}
